module.exports = __webpack_public_path__ + "img/GreekTechSpearmanS2_ua.55ca9d0f.webp";